import { render, staticRenderFns } from "./EditNotificaciones.vue?vue&type=template&id=53ec0176"
import script from "./EditNotificaciones.vue?vue&type=script&lang=js"
export * from "./EditNotificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ec0176')) {
      api.createRecord('53ec0176', component.options)
    } else {
      api.reload('53ec0176', component.options)
    }
    module.hot.accept("./EditNotificaciones.vue?vue&type=template&id=53ec0176", function () {
      api.rerender('53ec0176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/tasks/EditNotificaciones.vue"
export default component.exports